import { Fragment } from "react";
import { HeadingTitle } from "../ModalContainer";
import secureLocalStorage from "react-secure-storage";
import { Button } from "@mui/material";

const SKUDimensions = ({ close }) => {
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;
  console.log("TOKEN: ", token);
  return (
    <Fragment>
      <HeadingTitle
        title={`SKU Dimensions`}
        center={false}
        closeModal={close}
      />

      <div className="sku-dimension-row">
        <p>
          This SKU Code does not have values for height, width, length, and dead
          weight. Please enter the required values.
        </p>
        <div>
          <label htmlFor="" className="label">
            Length
          </label>{" "}
          <br />
          <input type="text" placeholder="Enter Value" />
        </div>
        <div>
          <label htmlFor="" className="label">
            Width
          </label>
          <br />
          <input type="text" placeholder="Enter Value" />
        </div>
        <div>
          <label htmlFor="" className="label">
            Height
          </label>
          <br />
          <input type="text" placeholder="Enter Value" />
        </div>
        <div>
          <label htmlFor="" className="label">
            Dead Weight
          </label>
          <br />
          <input type="text" placeholder="Enter Value" />
        </div>

        <div className="create-sku">
          <Button>Create</Button>
        </div>
      </div>
    </Fragment>
  );
};

export default SKUDimensions;
